
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { DeductiblePaymentEnum } from './Passenger/models/TransportationPermission';

@Component({
  components: {
  },
})
export default class DeductiblePaymentSelect extends Vue {
  selectedDeductiblePayment: DeductiblePaymentEnum;

  constructor() {
    super();
    this.selectedDeductiblePayment = DeductiblePaymentEnum.Invoice;
  }

  @Prop({ required: true }) value: DeductiblePaymentEnum | null;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: ''}) hint: string;
  @Prop({ default: ''}) persistentHint: string;

  @Watch('value', { immediate: true }) onValueChanged() {
    if (this.value === null || this.value === undefined) {
      return this.selectDeductiblePayment(DeductiblePaymentEnum.Car);
    }
    this.selectedDeductiblePayment = this.value;
  }

  get deductiblePaymentOptions() {
    return [
      {
        text: this.$i18n.translate('transportationPermission.deductiblePayment.car', 'Driver'),
        value: DeductiblePaymentEnum.Car,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductiblePayment.invoice', 'Invoice'),
        value: DeductiblePaymentEnum.Invoice,
      },
    ];
  }

  selectDeductiblePayment(deductiblePayment: DeductiblePaymentEnum) {
    this.selectedDeductiblePayment = deductiblePayment;
    this.$emit('input', this.selectedDeductiblePayment);
  }

}
